import { isRequestCancelled } from "../../classes/utils/RequestUtils";
import apiClient from "../../clients/apiClient";
import API_ENDPOINTS from "../../config/apiEndpointsConfig";

export const prepareReportEndpoint = async (reportPayload, digitalTwinId) => {
  const endpoint = API_ENDPOINTS.PREPARE_REPORT(digitalTwinId);
  try {
    const response = await apiClient.post(endpoint, reportPayload);
    return response.data;
  } catch (error) {
    throw new Error(`Error generating report: ${error.message}`);
  }
};

export const downloadReportEndpoint = async (patientId, fileName) => {
  const endpoint = API_ENDPOINTS.GET_PATIENT_REPORT(patientId, fileName);
  try {
    const response = await apiClient.get(endpoint, {
      responseType: "blob",
    });

    // Create a blob from the response
    const blob = new Blob([response.data], {
      type: response.headers["content-type"] || "application/octet-stream",
    });

    // Create a download link and trigger download
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();

    // Cleanup
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    return { success: true };
  } catch (error) {
    throw new Error(`Error downloading report: ${error.message}`);
  }
};

export const deleteReportEndpoint = async (patientId, fileName) => {
  const endpoint = API_ENDPOINTS.DELETE_REPORT(patientId, fileName);
  try {
    const response = await apiClient.delete(endpoint);
    return response.data;
  } catch (error) {
    const errorMessage =
      error?.response?.data?.detail ||
      error?.response?.data?.error ||
      error.message;
    throw new Error(`${errorMessage}`);
  }
};

export const getReportsListEndpoint = async (patientId, signal) => {
  const endpoint = API_ENDPOINTS.GET_PATIENT_REPORTS_LIST(patientId);
  try {
    const response = await apiClient.get(endpoint, { signal });
    return response.data;
  } catch (error) {
    if (isRequestCancelled(error)) throw error;
    if (error?.response?.status === 404) return [];
    throw new Error(`Error fetching reports list: ${error.message}`);
  }
};
